import gql from 'graphql-tag';

export default gql`
  fragment callNgReasonFragment on CallNgReason {
    id
    projectId
    reason
  }
`;
